import React from 'react';
import MainController from './MainController';
import { BrowserRouter as Router } from 'react-router-dom';

function App() {
  return (
    <Router>
      <MainController/>
    </Router>
  );
}

export default App;
